import React, { useRef } from "react";
import { ChevronLeft, Zap, RotateCcw, Image } from "lucide-react";

const CameraView = ({ onBack, onCapture, styles }) => {
  const cameraInputRef = useRef(null);
  const galleryInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onCapture(file);
    }
  };

  return (
    <div style={{ ...styles.container, backgroundColor: "#0A0E1A" }}>
      {/* Header */}
      <div
        style={{
          backgroundColor: "#0033A0",
          padding: "12px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "white",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <ChevronLeft onClick={onBack} style={{ cursor: "pointer" }} size={24} />
          <span style={{ fontSize: "18px", fontWeight: "500" }}>
            Capture Activity
          </span>
        </div>
        <div style={{ display: "flex", gap: "20px" }}>
          <Zap size={20} />
          <RotateCcw size={20} />
        </div>
      </div>

      {/* Preview Area */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "#666",
        }}
      >
        <Image size={80} strokeWidth={1} style={{ opacity: 0.5 }} />
        <span style={{ marginTop: 10 }}>Tap shutter or gallery</span>
      </div>

      {/* Hidden Inputs */}
      <input
        type="file"
        accept="image/*"
        capture="environment"
        ref={cameraInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <input
        type="file"
        accept="image/*"
        ref={galleryInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {/* Controls */}
      <div
        style={{
          padding: "40px 20px",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          backgroundColor: "rgba(0,0,0,0.4)",
        }}
      >
        {/* Gallery */}
        <div
          onClick={() => galleryInputRef.current.click()}
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "8px",
            border: "2px solid #555",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#222",
            cursor: "pointer",
          }}
        >
          <Image size={24} color="#555" />
        </div>

        {/* Shutter */}
        <div
          onClick={() => cameraInputRef.current.click()}
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            border: "4px solid white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: "65px",
              height: "65px",
              borderRadius: "50%",
              backgroundColor: "#FFC20E",
            }}
          />
        </div>

        <div style={{ width: "50px" }} />
      </div>
    </div>
  );
};

export default CameraView;